import React from 'react'
import ReactDOM from 'react-dom'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'

import App from 'app/App'

import './index.css'

/**
 * Asynchronous entrypoint.
 *
 * React is only initialized once feature flag provider is connected.
 */
;(async () => {
  const { vendors = {} } = window.Rune.Carrot.config

  const NoopProvider = ({ children }) => children
  const LDProvider = vendors.launchdarkly?.disabled
    ? NoopProvider
    : await asyncWithLDProvider({
        clientSideID: vendors.launchdarkly.clientSideId,
      })

  const rootNode = document.getElementById('root')

  ReactDOM.render(
    <LDProvider>
      <App />
    </LDProvider>,
    rootNode,
  )
})()
